// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"2f15f18f","453":"b3583c4a","457":"84830f3b"}[chunkId] + ".chunk.js";
};